import {
  GET_CITY_LIST_BY_REGION_ID
} from '../../actionTypes';
import {
  PENDING,
  SUCCESS,
  FAILURE,
  END
} from '../../../utils/status';


const INIT_STATE = {
  status: undefined,
  pager: {},
  data: []
};

export function select(state, key) {
  let cityList = state.city.cityList;

  if (!key) {
    return cityList;
  } else {
    return cityList[key];
  }
}


export default function reducer(state = INIT_STATE, action) {
  let nextState;
  /**
   * todo 做分页判断
   */
  if (action.type === GET_CITY_LIST_BY_REGION_ID) {
    switch (action.status) {
      case PENDING:
      case FAILURE:
        nextState = {
          ...state,
          status: action.status
        };
        break;
      case SUCCESS:
      case END:
        nextState = {
          ...state,
          status: action.status,
          pager: action.pager
        };

        if (nextState.pager.page === 1) {
          nextState.data = action.data;
        } else {
          nextState.data = state.data.concat(action.data);
        }

        break;
      default:
        nextState = state;
    }
  } else {
    nextState = state;
  }

  return nextState;
}



// WEBPACK FOOTER //
// ./src/store/reducers/city/cityList.js